import { IconDone, IconWarningOutline, Stepper } from '@capitalise/ui-design-system';
import { FundingMatchStatus, FundingMatchStatusLabel } from 'enums/funding-match-status';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import PropTypes from 'prop-types';

const defaultSteps = [
  ' ',
  FundingMatchStatusLabel[FundingMatchStatus.inReview],
  ' ',
  FundingMatchStatusLabel[FundingMatchStatus.indicativeOffer],
  ' ',
  FundingMatchStatusLabel[FundingMatchStatus.inUnderwriting],
  ' ',
  FundingMatchStatusLabel[FundingMatchStatus.paidOut],
];

export const statusIntoIndexes = {
  [FundingMatchStatus.submitted]: 1,
  [FundingMatchStatus.inReview]: 2,
  [FundingMatchStatus.contactMade]: 3,
  [FundingMatchStatus.indicativeOffer]: 4,
  [FundingMatchStatus.awaitingClientDecision]: 5,
  [FundingMatchStatus.inUnderwriting]: 6,
  [FundingMatchStatus.underwrittenOffer]: 7,
  [FundingMatchStatus.professionsInstructed]: 7,
  [FundingMatchStatus.professionsSignOff]: 7,
  [FundingMatchStatus.finalCreditSignOff]: 7,
  [FundingMatchStatus.clientAccepted]: 7,
  [FundingMatchStatus.paidOut]: 8,
  [FundingMatchStatus.passed]: 8,
  [FundingMatchStatus.lenderDecline]: 8,
  [FundingMatchStatus.lenderRejected]: 8,
  [FundingMatchStatus.lost]: 8,
  [FundingMatchStatus.cancelled]: 8,
  [FundingMatchStatus.clientDecline]: 8,
  [FundingMatchStatus.nonResponsive]: 8,
};

export const stepsToHide = [
  FundingMatchStatus.passed,
  FundingMatchStatus.lenderDecline,
  FundingMatchStatus.lenderRejected,
  FundingMatchStatus.lost,
  FundingMatchStatus.cancelled,
  FundingMatchStatus.clientDecline,
  FundingMatchStatus.nonResponsive,
];

const makeStepsByStatus = (status, currentStep, mobile) => {
  if (stepsToHide.includes(status)) {
    return [...Array(7).fill(''), FundingMatchStatusLabel[status]];
  }

  const steps = mobile ? Array(8).fill('') : [...defaultSteps];
  steps[currentStep - 1] = FundingMatchStatusLabel[status];
  return steps;
};

const getStepperColor = (status) => {
  if (status === FundingMatchStatus.lenderRejected) {
    return 'warning';
  }

  return stepsToHide.includes(status) ? 'danger' : 'green';
};

const MatchStepper = ({ status }) => {
  const currentStep = statusIntoIndexes[status];
  const { isMobile } = useMediaQuery();
  const availableSteps = makeStepsByStatus(status, currentStep, isMobile);

  return (
    <Stepper
      steps={availableSteps}
      currentStep={currentStep}
      completed={currentStep === defaultSteps.length}
      currentStepPosition="top"
      inverted={true}
      aria-label="currentStep"
      color={getStepperColor(status)}
      icon={
        stepsToHide.includes(status) ? (
          <IconWarningOutline color="white" height="3xsmall" />
        ) : (
          <IconDone color="white" height="3xsmall" />
        )
      }
    />
  );
};

MatchStepper.propTypes = {
  status: PropTypes.number.isRequired,
  product: PropTypes.number,
};

export default MatchStepper;
